// extracted by mini-css-extract-plugin
module.exports = {"LEFT_HEADER_WIDTH":"41px","RIGHT_HEADER_WIDTH":"41px"};